import './TEventDialog.scss';

import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import NP from "../../1. Core/NP";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import IconSelect from "../../1. Core/Controls/Select/IconSelect";
import {clearLocationsCache, getCountries, getLocations, getTournaments, ITournament} from "../Util";
import {EventTournament, Location, SportType} from "../types";
import DateInput from "../../1. Core/Controls/DateInput/DateInput";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import LocationListDialog from "../Library/Dialogs/LocationListDialog";
import TimeEdit, {TimeEditMode} from "../../1. Core/Controls/TimeEdit/TimeEdit";
import Button from "../../1. Core/Controls/Button/Button";
import ImageTextField from "../../1. Core/Controls/TextField/ImageTextField";
import CheckBox from "../../1. Core/Controls/CheckBox/CheckBox";
import TVStreamListDialog from "./TVStreamListDialog";


let moment = require('moment');

export default class TEventDialog extends Dialog {
    private _name: TextField;
    private _dateInput: DateInput;
    private _Date: Date;
    private _tournamentCombo: IconSelect;

    private _locationCombo: IconSelect;

    private _Event: EventTournament;
    private _addloCButton: IconToggleButton;
    private _timeInput: TimeEdit;
    private _Type: SportType;
    private _fileVideoPath: TextField;

    private _fullVideoHl: TextField;
    private _optimalVideoHl: TextField;
    private _shortlVideoP: TextField;
    private _videoStreamUrl: TextField;
    private _idValue: TextField;
    private _tvStreamBtn: Button;
    private _posterField: ImageTextField;
    private _siteNoIndex: CheckBox;


    _initFields(settings: object) {
        this._Type = SportType.MMA;
        this._Event = null;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = NP.RM.getString('Event');
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
        this._Width = 450;
    }

    _render() {
        super._render();

        this.addClass('t-event-dlg ')

        this._Date = new Date();


        this._name = new TextField({
            FloatingLabel: NP.RM.getString('Name'),
            ParentNode: this._contentNode
        });

        this._tournamentCombo = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Tournament')
        });

        this._dateInput = new DateInput({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Date'),
            EvChanged: () => {
                this._Date = this._dateInput.getValue();
            }
        });

        this._idValue = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Id',
            EnableEdit: true
        });

        this._timeInput = new TimeEdit({
            ParentNode: this._contentNode,
            Mode: TimeEditMode.HoursMinutes,
            FloatingLabel: NP.RM.getString('UTCTime'),
        })

        this._videoStreamUrl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('VideoStreamUrl'),
        })

        this._posterField = new ImageTextField({
            ParentNode: this._contentNode,
            UploadApiPath: '/t-events/creates3Link',
            TextFieldSettings: {
                FloatingLabel: 'Poster (768×512)',
            },
        });

        this._siteNoIndex = new CheckBox({
            ParentNode: this._contentNode,
            RK: 'SiteNoIndexEvent',
        });

        this._fileVideoPath = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('PathToVideoFile'),
        })

        this._fullVideoHl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Event Highlight url'
        });

        this._optimalVideoHl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Maincard Highlight url'
        });

        this._shortlVideoP = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Prelims Highlight url'
        });

        this._locationCombo = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Location'),
            Width: 348
        });

        this._addloCButton = new IconToggleButton({
            FontImage: NP.FontImages.edit,
            Tooltip: NP.RM.getString('EditLocList'),
            ParentNode: this._contentNode,
            EvClick: () => {
                (new LocationListDialog({
                    EvClosed: () => this.updateLocations()
                })).show()
            }
        })

        this._addloCButton.getRoot().style.verticalAlign = 'bottom';
        this._addloCButton.getRoot().style.bottom = '9px'

        this._tvStreamBtn = new Button({
            ParentNode: this._contentNode,
            Content: 'TV/Stream (event override)',
            EvClick: () => {
                if (!this._Event)
                    this._Event = {} as EventTournament;
                new TVStreamListDialog({
                    TVStreamData: this._Event.TVStreamUrl,
                    EvOkButtonClick: (dlg, args) => {
                        // Empty / "[]" → inherit promotion default (no duplicate on event).
                        const v = (args.Value || '').trim();
                        this._Event.TVStreamUrl = (!v || v === '[]') ? null : args.Value;
                    }
                }).show()
            }
        });


        getTournaments(this._Type).then((res: ITournament[]) => {
            if (this._tournamentCombo) {
                let items = res.map(t => ({
                    Value: t.Id,
                    FontImage: NP.FontImages.integration,
                    Content: t.Name,
                    Data: t
                }));
                this._tournamentCombo.setItems(items);
                if (this._Event && this._Event.TournamentId)
                    this._tournamentCombo.setValue(this._Event.TournamentId)
                else if (items.length > 0)
                    this._tournamentCombo.setValue(items[0].Value);
            }
        });

        this.updateLocations();

        if (this._Event) {
            this._name.setValue(this._Event.Name)
            this._fileVideoPath.setValue(this._Event.VideoFilePath)
            this._idValue.setValue(this._Event.GloryEventID);

            this._fullVideoHl.setValue(this._Event.HLUrl_Full)
            this._optimalVideoHl.setValue(this._Event.HLUrl_Optimal)
            this._shortlVideoP.setValue(this._Event.HLUrl_Short)
            this._videoStreamUrl.setValue(this._Event.VideoStreamUrl)
            this._posterField.setValue(this._Event.PosterUrl || '')
            this._siteNoIndex.setChecked(!!this._Event.SiteNoIndex, false)

            //this._tvStreamField.setValue(this._Event.TVStreamUrl)

            let date = moment(this._Event.Date)
            if (date.isValid()) {
                this._dateInput.setValue(date.toDate());
                this._timeInput.setValue(date.format('HH:mm'));
            }
        } else
            this._dateInput.setValue(new Date());
    }

    updateLocations() {
        clearLocationsCache();
        getLocations().then((res: Location[]) => {
            if (this._locationCombo) {
                let items = [
                    {Value: null, Content: ' ', FontImage: NP.FontImages.map},
                    ...res.map(t => ({Value: t.Id, FontImage: NP.FontImages.map, Content: t.Name}))
                ];


                this._locationCombo.setItems(items);
                if (this._Event && this._Event.LocationId)
                    this._locationCombo.setValue(this._Event.LocationId, false)
                else
                    this._locationCombo.setValue(null);
            }
        });
    }


    async _onOkButtonClick() {
        const name = this._name.getValue().trim();
        if (!name) {
            NP.showMessage({
                Caption: NP.RM.getString('EditEvent'),
                Content: NP.RM.getString('EditEventPropIsBlank') + ' ' + NP.RM.getString('Name'),
            });
            return;
        }
        if (!this._tournamentCombo.getValue()) {
            NP.showMessage({
                Caption: NP.RM.getString('EditEvent'),
                Content: NP.RM.getString('EditEventPropIsBlank') + ' ' + NP.RM.getString('Tournament'),
            });
            return;
        }

        if (!this._Event)
            this._Event = {} as EventTournament;

        const gloryId = (this._idValue.getValue() || '').trim();
        this._Event.GloryEventID = gloryId || null;
        this._Event.Name = name;
        const timeRaw = (this._timeInput.getValue() || '00:00').trim();
        const time = timeRaw.length <= 5 ? timeRaw + ':00' : timeRaw;
        this._Event.Date = moment(this._dateInput.getValue()).format('YYYY-MM-DD') + ' ' + time;
        this._Event.TournamentId = this._tournamentCombo.getValue();
        this._Event.LocationId = this._locationCombo.getValue();
        this._Event.VideoFilePath = this._fileVideoPath.getValue();
        this._Event.VideoStreamUrl = this._videoStreamUrl.getValue();

        //this._Event.TVStreamUrl = this._tvStreamField.getValue()


        this._Event.HLUrl_Full = this._fullVideoHl.getValue()
        this._Event.HLUrl_Optimal = this._optimalVideoHl.getValue()
        this._Event.HLUrl_Short = this._shortlVideoP.getValue()
        this._Event.PosterUrl = (this._posterField.getValue() || '').trim() || null
        this._Event.SiteNoIndex = this._siteNoIndex.getChecked()

        if (this._Event.Id)
            await ServerAPI.callUiApi(`/t-events/${this._Event.Id}`, this._Event, 'POST');
        else
            await ServerAPI.callUiApi('/t-events', this._Event, 'PUT')


        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}
